// Utils
import { get } from "../utils/fetchUtils";

// Utils
import { generateTagsQueryParams } from "../utils/apiUtils";

// Constants
const baseUrl = "https://innovate.symphony.com/wp-json/wp/v2";
//const baseUrl = "https://staging-symphony-innovate.pantheonsite.io/wp-json/wp/v2";

export class Api {
    static setHeaders() {
        const headers = new Headers();
        return headers;
    }

    static getBlocks(onSuccess, onError) {
        const headers = new Headers();
        const url = `${baseUrl}/block_global/`;
        return get(url, headers, onSuccess, onError);
    }

    static getConference({ id }, onSuccess, onError) {
        const headers = new Headers();
        const url = `${baseUrl}/conference_global/${id}`;
        return get(url, headers, onSuccess, onError);
    }

    static getConferenceBySlug({ slug }, onSuccess, onError) {
        const headers = new Headers();
        const url = `${baseUrl}/conference_global?slug=${slug}`;
        return get(url, headers, onSuccess, onError);
    }

    static getConferences(onSuccess, onError) {
        const headers = new Headers();
        const url = `${baseUrl}/conference_global?per_page=100`;
        return get(url, headers, onSuccess, onError);
    }

    static getFilters(onSuccess, onError) {
        const headers = new Headers();
        const url = `${baseUrl}/filter_global?per_page=100`;
        return get(url, headers, onSuccess, onError);
    }

    static getTags(onSuccess, onError) {
        const headers = new Headers();
        const url = `${baseUrl}/tags?per_page=100`;
        return get(url, headers, onSuccess, onError);
    }

    static getVideo({ id }, onSuccess, onError) {
        const headers = new Headers();
        const url = `${baseUrl}/video_global/${id}`;
        return get(url, headers, onSuccess, onError);
    }

    static getVideos(
        { currentPage, operator, selectedTags },
        onSuccess,
        onError
    ) {
        const headers = new Headers();
        const tagsQueryParams = generateTagsQueryParams(selectedTags, operator);
        const url = `${baseUrl}/video_global?page=${currentPage}&per_page=99${tagsQueryParams}`;
        return get(url, headers, onSuccess, onError);
    }

    static getVideosBySearchTerm({ search }, onSuccess, onError) {
        const headers = new Headers();
        const url = `${baseUrl}/video_global?per_page=99&search=${search}`;
        return get(url, headers, onSuccess, onError);
    }
}
